module.exports = __webpack_public_path__ + "static/M3-07-image-1-7ba1ffc8d15463008186f9d5b80bc8f6.png";